// src/language/dashboardLanguage.js
const dashboardLanguage = {
  en: {
    pageTitle: 'Dashboard',
    month: 'Month',
    quarter: 'Quarter',
    year: 'Year',
    fromDate: 'From Date',
    toDate: 'To Date',
    customDate: 'Custom Date',

    // Card titles (renamed)
    totalExpenses: 'Total Expenses',
    totalSale: 'Total Sale',
    totalProfit: 'Total Profit',

    // Milk type labels
    cow: 'Cow',
    buffalo: 'Buffalo',

    // Detail panel section labels
    purchaseMilk: 'Purchase Milk',
    otherExpenses: 'Other Expenses',
    otherSales: 'Other Sales',

    // Detail table columns
    productType: 'Product Type',
    productName: 'Product Name',
    amount: 'Amount',
    date: 'Date',
    noData: 'No entries for this period.',

    // Chart
    soldMilkMonthWise: 'Sold Milk (Month Wise)',

    months: {
      jan: 'Jan',
      feb: 'Feb',
      mar: 'Mar',
      apr: 'Apr',
      may: 'May',
      jun: 'Jun',
    },
  },
  mr: {
    pageTitle: 'डॅशबोर्ड',
    month: 'महिना',
    quarter: 'तिमाही',
    year: 'वर्ष',
    fromDate: 'तारीख पासून',
    toDate: 'तारीख पर्यंत',
    customDate: 'हवी ती तारीख',

    // Card titles (renamed)
    totalExpenses: 'एकूण खर्च',
    totalSale: 'एकूण विक्री',
    totalProfit: 'एकूण नफा',

    // Milk type labels
    cow: 'गायीचे',
    buffalo: 'म्हशीचे',

    // Detail panel section labels
    purchaseMilk: 'दूध खरेदी',
    otherExpenses: 'इतर खर्च',
    otherSales: 'इतर विक्री',

    // Detail table columns
    productType: 'उत्पादन प्रकार',
    productName: 'उत्पादनाचे नाव',
    amount: 'रक्कम',
    date: 'तारीख',
    noData: 'या कालावधीत कोणत्याही नोंदी नाहीत.',

    // Chart
    soldMilkMonthWise: 'महिना निहाय विकलेले दूध',

    months: {
      jan: 'जाने',
      feb: 'फेब्रु',
      mar: 'मार्च',
      apr: 'एप्रि',
      may: 'मे',
      jun: 'जून',
    },
  },
};

export default dashboardLanguage;
